import UserService from "#services/UserService";
import { Button, Modal, Title, useToast } from "@validereinc/common-components";
import * as PropTypes from "prop-types";
import React, { useState } from "react";
import "./ConfirmationModal.css";

const ReactivateConfirmationModal = ({
  memberProfile,
  updateMemberProfile,
  onHide,
}) => {
  const { name } = memberProfile;
  const [buttonState, setButtonState] = useState("enabled");
  const { toast } = useToast();

  const onReactivateClicked = () => {
    setButtonState("loading");

    UserService.requestReactivateUser(memberProfile.id)
      .then(() => {
        updateMemberProfile();
        onHide();
        toast.push({
          intent: "success",
          description: `Successfully reactivated ${name}.`,
        });
      })
      .catch(() => {
        setButtonState("enabled");
      });
  };

  return (
    <Modal
      className="confirmationModal"
      open={true}
      onClose={buttonState === "enabled" ? onHide : null}
    >
      <Modal.Header>
        <Title>Reactivate Account</Title>
      </Modal.Header>

      <Modal.Body>
        <div>Do you wish to reactivate {name}?</div>
      </Modal.Body>

      <Modal.Footer className="confirmationModal__footer">
        <Button
          onClick={onHide}
          disabled={buttonState !== "enabled"}
        >
          Cancel
        </Button>

        <Button
          className="confirmButton"
          variant="primary"
          onClick={onReactivateClicked}
          isLoading={buttonState === "loading"}
          disabled={buttonState !== "enabled"}
        >
          Reactivate
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ReactivateConfirmationModal.propTypes = {
  memberProfile: PropTypes.object,
  onHide: PropTypes.func.isRequired,
  updateMemberProfile: PropTypes.func.isRequired,
};

export default ReactivateConfirmationModal;
